/**
 * 진행 중인 점검을 기기에 임시저장한다.
 *
 * 점검 화면은 체크·답변·메모를 메모리에만 들고 있었다. 전화 한 통에 앱이
 * 뒤로 밀리거나 알림을 눌러 화면을 옮기면 그때까지 걸어 다니며 만든 기록이
 * 통째로 사라졌다. 그래서 시설 하나를 점검표 하나로 도는 방식을 못 썼다.
 *
 * 사진은 촬영 즉시 서버로 올라가 URL 만 남으므로 여기 함께 담을 수 있다.
 * 파일 객체였다면 저장 자체가 불가능했다.
 *
 * 기기 안에만 둔다. 현장 점검은 한 사람이 한 기기로 하고, 서버에 두면 누가
 * 소유하는지, 두 기기에서 동시에 열면 어느 쪽이 이기는지를 전부 정해야 한다.
 */

const PREFIX = 'inspectionDraft';

/**
 * 임시저장을 얼마나 붙들고 있을지.
 *
 * 제출되지 않은 사진은 서버가 24시간 뒤 지운다. 그보다 짧게 잡아야 사진이
 * 사라진 초안을 되살리는 일이 없다. 하루를 넘겨 이어 하는 점검도 없다.
 */
const MAX_AGE_HOURS = 12;

const keyOf = (facilityId, sectionId) => `${PREFIX}:${facilityId}:${sectionId}`;

/**
 * 점검표 구성을 나타내는 값. 항목이 추가·삭제되면 달라진다.
 *
 * 답변은 항목 id 로 물려 있어서, 사라진 항목의 답변을 되살리면 화면과 어긋난다.
 * 항목 문구만 고쳐진 경우는 되살려도 문제가 없으므로 id 만 본다.
 */
export const fingerprintOf = (templateItems) =>
  (templateItems || []).map((item) => item.id).join(',');

const InspectionDraft = {
  read(facilityId, sectionId) {
    try {
      const raw = localStorage.getItem(keyOf(facilityId, sectionId));
      if (!raw) return null;

      const draft = JSON.parse(raw);
      const ageHours = (Date.now() - (draft.savedAt || 0)) / 36e5;
      if (ageHours > MAX_AGE_HOURS) {
        InspectionDraft.clear(facilityId, sectionId);
        return null;
      }
      return draft;
    } catch (err) {
      // 형식이 깨졌으면 되살릴 방법이 없다. 다음 저장을 막지 않도록 치운다.
      InspectionDraft.clear(facilityId, sectionId);
      return null;
    }
  },

  write(facilityId, sectionId, draft) {
    try {
      localStorage.setItem(
        keyOf(facilityId, sectionId),
        JSON.stringify({ ...draft, savedAt: Date.now() }),
      );
    } catch (err) {
      // 저장 공간이 찼거나 사생활 보호 모드일 수 있다. 점검 자체는 계속돼야
      // 하므로 삼킨다.
    }
  },

  clear(facilityId, sectionId) {
    try {
      localStorage.removeItem(keyOf(facilityId, sectionId));
    } catch (err) {
      /* 지우지 못해도 만료 시간이 걷어간다 */
    }
  },
};

export default InspectionDraft;
